import { Stack } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import type { ChatRailTokens } from "../../tokens";
import { JsonResultRenderer } from "./JsonResultRenderer";
import { ScalarRow, pickStringField } from "./registry";

export function PersonRenderer({
  kind,
  payload,
  T,
}: {
  kind: "invocation" | "result";
  payload: unknown;
  T: ChatRailTokens;
}) {
  if (kind === "invocation") return <JsonResultRenderer payload={payload} T={T} />;

  const id = pickStringField(payload, "id", "person_id");
  const name = (() => {
    if (!payload || typeof payload !== "object") return null;
    const o = payload as Record<string, unknown>;
    const first = typeof o.first_name === "string" ? o.first_name : "";
    const last = typeof o.last_name === "string" ? o.last_name : "";
    const joined = [first, last].filter(Boolean).join(" ").trim();
    return joined || pickStringField(payload, "name", "display_name", "full_name");
  })();
  const email = pickStringField(payload, "email", "primary_email");
  const company = pickStringField(payload, "company_name", "organization_name");

  if (!name && !id) return <JsonResultRenderer payload={payload} T={T} />;

  return (
    <Stack spacing={0.5}>
      {name && id ? (
        <ScalarRow
          label="person"
          value={
            <RouterLink to={`/contacts/${id}`} style={{ color: T.accent, textDecoration: "none" }}>
              {name}
            </RouterLink>
          }
          T={T}
        />
      ) : name ? (
        <ScalarRow label="person" value={name} T={T} />
      ) : null}
      {email && <ScalarRow label="email" value={email} T={T} />}
      {company && <ScalarRow label="company" value={company} T={T} />}
    </Stack>
  );
}
